var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('div',{staticClass:"pa-8"},[_c('pre',{staticStyle:{"font-size":"0.9em"},attrs:{"lang":"xml"}},[_vm._v(_vm._s(_vm.xmlString))])]),_c('v-divider'),_c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.close()}}},[_vm._v(" Close ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }